export const getGender = (fullName: string) => {
  const nombresFemeninosSinA = new Set([
    'isabel',
    'carmen',
    'beatriz',
    'pilar',
    'rosario',
    'ines',
    'belen',
    'luz',
    'abigail',
    'ruth',
  ]);

  const nombresMasculinosConA = new Set([
    'andrea',
    'bautista',
    'luca',
    'noa',
    'sasha',
    'matias',
    'nicolas',
    'tomas',
  ]);

  if (!fullName) return 'Bienvenido/a';

  const firstName = fullName.trim().split(' ')[0].toLowerCase();

  if (nombresFemeninosSinA.has(firstName)) return 'Bienvenida';
  if (nombresMasculinosConA.has(firstName)) return 'Bienvenido';
  if (firstName.endsWith('a')) {
    return 'Bienvenida';
  }

  return 'Bienvenido';
};
